import { getCheckoutStore } from 'modules/ScrShopNew/store/slices/checkout/selectors';
import { getProductByID } from 'modules/ScrShopNew/store/slices/products/selectors';
import { isShopActiveSelector } from 'modules/ScrShopNew/store/slices/shop/selectors';
import { trackEventAction } from 'old-store/actions';
import { useAppDispatch, useAppSelector } from './redux';
import { useHistory } from 'react-router-dom';
import { get } from 'lodash';
import { clearOptionAction } from 'modules/ScrShopNew/store/slices/shop';

export const useSaleBannersShopNavigate = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { couponCodeAdvertising, freeShipping } = useAppSelector((state) => state.banners);
  const isShopActive = useAppSelector(isShopActiveSelector);
  const { grandProductGrossPrice } = useAppSelector(getCheckoutStore);
  const discount = get(couponCodeAdvertising, 'coupon.discounts[0]', {}) as any;

  const isGrandProductGrossPricePresented = typeof grandProductGrossPrice === 'number';
  const isShowFreeShipping = isShopActive && freeShipping && isGrandProductGrossPricePresented;

  const product = useAppSelector(getProductByID)(discount.productId);

  const navigateToShop = () => {
    dispatch(clearOptionAction());

    if (discount.type === 'productGroup' && discount.productGroupId) {
      dispatch(
        trackEventAction({
          name: 'clicked-action',
          payload: {
            button_id: 'promo-banner',
            is_coupon_code_advertising: couponCodeAdvertising,
            is_free_shipping: isShowFreeShipping,
            location: 'shop',
            placement: 'modal'
          }
        })
      );

      history.push(`/shop-new/products/${discount.productGroupId}`);

      return;
    }

    if (discount.type === 'product' && discount.productId) {
      dispatch(
        trackEventAction({
          name: 'clicked-action',
          payload: {
            button_id: 'promo-banner',
            is_coupon_code_advertising: couponCodeAdvertising,
            is_free_shipping: isShowFreeShipping,
            location: 'shop',
            placement: 'modal'
          }
        })
      );

      history.push(`/shop-new/products/${product?._productGroup}/${product?.slug}?grouped`);

      return;
    }

    history.push('/shop-new');
  };

  return navigateToShop;
};
